import { defineMessages } from 'react-intl';

export const messages: {
	webPage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webPages: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	project: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goals: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tags: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	webPage: {
		id: 'search-page.products.custom-website',
		defaultMessage: 'Web page',
		description:
			'Singular noun label for a web page result type shown in the search page to identify content indexed from a custom website.',
	},
	webPages: {
		id: 'search-page.products.custom-websites',
		defaultMessage: 'Web pages',
		description:
			'Plural noun label for web page result types shown in the search page to identify multiple content items indexed from custom websites.',
	},
	project: {
		id: 'search-page.nouns.project',
		defaultMessage: 'Project',
		description:
			'Singular noun label for a project entity, used in the search page to label project-type results (e.g. Atlas projects).',
	},
	projects: {
		id: 'search-page.nouns.projects',
		defaultMessage: 'Projects',
		description:
			'Plural noun label for project entities, used in the search page to label multiple project-type results (e.g. Atlas projects).',
	},
	goal: {
		id: 'search-page.nouns.goal',
		defaultMessage: 'Goal',
		description:
			'Singular noun label for a goal entity, used in the search page to label goal-type results (e.g. Atlas goals).',
	},
	goals: {
		id: 'search-page.nouns.goals',
		defaultMessage: 'Goals',
		description:
			'Plural noun label for goal entities, used in the search page to label multiple goal-type results (e.g. Atlas goals).',
	},
	tag: {
		id: 'search-page.nouns.tag',
		defaultMessage: 'Tag',
		description:
			'Singular noun label for a tag entity, used in the search page to label tag-type results.',
	},
	tags: {
		id: 'search-page.nouns.tags',
		defaultMessage: 'Tags',
		description:
			'Plural noun label for tag entities, used in the search page to label multiple tag-type results.',
	},
});
